import * as validators from '../../../../constants/validators';

export const config = {
  email: validators.email,
  firstName: validators.firstName,
  lastName: validators.lastName,
  password: validators.password,
  terms: {
    valuePropName: 'checked',
    rules: [
      {
        required: true,
        message: 'You must agree to the terms of service.',
      },
    ],
  },
  newsletter: {
    valuePropName: 'checked',
  },
};
